import { render, staticRenderFns } from "./ResultNotFound.vue?vue&type=template&id=28cc3c90&scoped=true&functional=true"
var script = {}
import style0 from "./ResultNotFound.vue?vue&type=style&index=0&id=28cc3c90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "28cc3c90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cc3c90')) {
      api.createRecord('28cc3c90', component.options)
    } else {
      api.rerender('28cc3c90', component.options)
    }
    module.hot.accept("./ResultNotFound.vue?vue&type=template&id=28cc3c90&scoped=true&functional=true", function () {
      api.rerender('28cc3c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ResultNotFound.vue"
export default component.exports